import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export const StyledFilterDashboard = styled("div")(() => ({
  minHeight: "50px",
  backgroundColor: "#F0F0F0",
  padding: "10px",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  fontFamily: "Inter",
  fontWeight: "700",
  fontSize: "14px",
  color: "black",
  border: "rgba(224, 224, 224, 1) 1px solid",
}));

export const StyledField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    height: "35px ",
    width: "160px",
    borderRadius: "25px",
    backgroundColor: "white !important",
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: "14px",
    border: "none",
    overflow: "hidden",
    marginTop: "3px",
    marginBottom: "3px",
    marginLeft: "10px",
    "&:hover": { border: "none" },
    "&.Mui-focused": {
      boxShadow: "none",
      border: "none !important",
    },
  },
}));

export const StyledDatePicker = styled(DatePicker)(() => ({
  "& .MuiOutlinedInput-root": {
    height: "31px ",
    width: "150px",
    borderRadius: "25px",
    backgroundColor: "#EBE8FC !important",
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: "12px",
    border: "none",
    overflow: "hidden",
    marginLeft: "10px",
    marginTop: "3px",
    marginBottom: "3px",
    "&:hover": { border: "none" },
    "&.Mui-focused": {
      boxShadow: "none",
      border: "none !important",
    },
  },
}));
